import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { useAsyncAction } from 'app/services';
import { transportCommandSend } from 'app/store/map';
import { getLastTransportCondition } from 'app/types';
import React from 'react';
import { useSelector } from 'react-redux';
const ACTIVE_SIM_LABELS = {
    0: 'СИМ_1',
    1: 'СИМ_2',
    '-1': 'Неопределена',
};
const MapTransportConditionTerminalList = () => {
    var _a;
    const { id, sim0, sim1, conditions } = useSelector((state) => state.map.transportSelectedItem);
    const { asyncAction: commandSubmit } = useAsyncAction(transportCommandSend);
    const handleResetTerminal = () => {
        commandSubmit(id, 'reset');
    };
    const lastCondition = getLastTransportCondition(conditions);
    const activeSim = lastCondition === null || lastCondition === void 0 ? void 0 : lastCondition.data.active_sim;
    const activeSimLabel = activeSim !== undefined
        ? (_a = {
            0: sim0 ? `СИМ_1: ${sim0}` : 'Номер не задан',
            1: sim1 ? `СИМ_2: ${sim1}` : 'Номер не задан',
            '-1': 'Неопределена',
        }[String(activeSim)]) !== null && _a !== void 0 ? _a : ACTIVE_SIM_LABELS[String(activeSim)]
        : undefined;
    return (React.createElement(List, { disablePadding: true, sx: (theme) => ({
            '.MuiListItem-root': {
                padding: theme.spacing(0),
                '.MuiListItemButton-root': {
                    padding: theme.spacing(1, 2),
                    overflow: 'hidden',
                    '&:after': {
                        content: '""',
                        width: '100%',
                        height: '1px',
                        bgcolor: theme.palette.divider,
                        position: 'absolute',
                        bottom: '0',
                    },
                    '&:hover': {
                        bgcolor: 'transparent',
                    },
                    '&.MuiListItemButton-primary': {
                        '.MuiListItemText-root': {
                            color: theme.palette.primary.main,
                        },
                    },
                    '&.MuiListItemButton-error': {
                        '.MuiListItemText-root': {
                            color: theme.palette.error.main,
                        },
                    },
                    '.MuiListItemText-root': {
                        display: 'flex',
                        margin: theme.spacing(0),
                        justifyContent: 'space-between',
                        '.MuiTypography-root': {
                            lineHeight: '24px',
                        },
                    },
                },
                '&:last-of-type': {
                    '.MuiListItemButton-root:after': {
                        display: 'none',
                    },
                },
            },
        }) },
        React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, disableRipple: true }, conditions.length !== 0 && activeSimLabel !== undefined && (React.createElement(ListItemText, { primary: '\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0430\u043A\u0442\u0438\u0432\u043D\u0430\u044F \u0421\u0418\u041C', secondary: activeSimLabel })))),
        React.createElement(ListItem, { onClick: handleResetTerminal },
            React.createElement(ListItemButton, { dense: true, className: 'MuiListItemButton-error' },
                React.createElement(ListItemText, { primary: '\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B' }))),
        React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, className: 'MuiListItemButton-error' },
                React.createElement(ListItemText, { primary: '\u041F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B \u043F\u043E \u0421\u041C\u0421' }))),
        React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, className: 'MuiListItemButton-primary' },
                React.createElement(ListItemText, { primary: '\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0441\u0438\u043C0' }))),
        React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, className: 'MuiListItemButton-primary' },
                React.createElement(ListItemText, { primary: '\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u0441\u0438\u043C1' }))),
        React.createElement(ListItem, null,
            React.createElement(ListItemButton, { dense: true, className: 'MuiListItemButton-primary' },
                React.createElement(ListItemText, { primary: '\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0441\u0438\u043C' })))));
};
export default MapTransportConditionTerminalList;
